import { render, staticRenderFns } from "./SearchHelpLink.vue?vue&type=template&id=505711f3&scoped=true&"
import script from "./SearchHelpLink.vue?vue&type=script&lang=js&"
export * from "./SearchHelpLink.vue?vue&type=script&lang=js&"
import style0 from "./SearchHelpLink.vue?vue&type=style&index=0&id=505711f3&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505711f3",
  null
  
)

export default component.exports